module.exports = __webpack_public_path__ + "static/img/Dylan-Walker.0fd1e28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dylan-Walker.jpg
// module id = tkST
// module chunks = 0